export const getCaptionId = (id, variant) => `${id}-${variant || "caption"}`;
